import RightPopupComponent from "components/RightPopup";

import '../index.less';
import '../themes/default.less';

export default class Pasport extends RightPopupComponent {

    insertInputs(props, props2, props3) {
        return (
            <div className="inputs flex gap16">
                {this.insertInput(props)}
                {this.insertInput(props2)}
                {props3 && this.insertInput(props3)}
            </div>
        );
    }

    render() {
        const { passport, data, onChangePersonalDate } = this.props;
        const active = passport ? "active" : "";

        return (
            <div className={`passport flex col gap16 ${active}`}>
                <div className="flex1 flex gap8">
                    <div className="flex gap1" style={{ flex: 2 }}>
                        {this.insertInput({
                            value: data['PSP_SERIES'],
                            itemStyle: "flex1",
                            label: "client.series",
                            placeHolder: "0000",
                            onChange: onChangePersonalDate.bind(this, "PSP_SERIES")
                        })}
                        {this.insertInput({
                            value: data['PSP_NUMBER'],
                            itemStyle: "flex1",
                            label: "client.number",
                            placeHolder: "000000",
                            onChange: onChangePersonalDate.bind(this, "PSP_NUMBER")
                        })}
                    </div>
                    <div style={{ flex: 1 }}>
                        {this.insertInput({
                            value: data['PSP_ISSUE_DATE'],
                            itemStyle: "flex1",
                            label: "client.whenIssued",
                            placeHolder: "01.01.2000",
                            validator: this._helper.inputValidators.date,
                            onChange: onChangePersonalDate.bind(this, "PSP_ISSUE_DATE")
                        })}
                    </div>
                </div>
                <div className="flex1 flex gap8">
                    <div className="flex gap1" style={{ flex: 2 }}>
                        {this.insertInput({
                            value: data['PSP_ISSUED_BY'],
                            itemStyle: "flex1",
                            label: "client.issuedBy",
                            placeHolder: "client.nameIssued",
                            validator: this._helper.inputValidators.capitalize,
                            onChange: onChangePersonalDate.bind(this, "PSP_ISSUED_BY")
                        })}
                    </div>
                    <div style={{ flex: 1 }}>
                        {this.insertInput({
                            value: data['PSP_DEP_CODE'],
                            label: "client.departmentCode",
                            placeHolder: "000-000",
                            format: "xxx-xxx",
                            validator: this._helper.inputValidators.format,
                            onChange: onChangePersonalDate.bind(this, "PSP_DEP_CODE")
                        })}
                    </div>
                </div>
                {this.insertInputs({
                    value: data['BIRTH_PLACE'],
                    label: "client.placeBirth",
                    placeHolder: "client.placeBirth",
                    validator: this._helper.inputValidators.capitalize,
                    onChange: onChangePersonalDate.bind(this, "BIRTH_PLACE")
                }, {
                    value: data['CITIZENSHIP'],
                    label: "client.citizenship",
                    validator: this._helper.inputValidators.capitalize,
                    placeHolder: "client.citizenship",
                    onChange: onChangePersonalDate.bind(this, "CITIZENSHIP")
                })}
            </div>
        );
    }
}

